import { Container } from '@/components/ui/Container'
import { Section } from '@/components/ui/Section'
import { siteConfig } from '@/config/site'

export function StorySection() {
  return (
    <Section surface="0" withBorder>
      <Container className="max-w-4xl">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 sm:gap-8 md:gap-12 items-start">
          <div>
            <h2 className="text-xl sm:text-2xl font-bold tracking-tight text-fg">
              The Genesis
            </h2>
            <span className="font-mono text-xs text-fg-muted mt-1 block">
              Ethos & Identity
            </span>
          </div>

          <div className="md:col-span-2 space-y-4 sm:space-y-6 text-sm sm:text-base text-fg-subtle leading-relaxed">
            <p>
              {siteConfig.name} was established with a singular conviction: Ethiopian businesses, enterprises, and innovators require software solutions developed to international engineering standards, without dependencies on poorly fitted off-the-shelf foreign templates.
            </p>
            <p>
              The company name originates from its founder, <strong className="text-fg font-semibold">{siteConfig.founder.name}</strong> (commonly known as <em>{siteConfig.founder.nickname}</em>). In the {siteConfig.founder.nameLanguage} language, the name signifies <strong className="text-fg font-semibold">"{siteConfig.founder.nameMeaning}"</strong>.
            </p>
            <p>
              This meaning was adopted not merely as an appellation, but as the governing baseline for every technical architecture, system contract, and user experience we produce: built to stand above.
            </p>
          </div>
        </div>
      </Container>
    </Section>
  )
}
